import {
  ModalLayout,
  Pagination,
} from "@wac-ui-dashboard/wac_component_library";
import React from "react";
import AddStatus from "../AddStatus";
import View from "../View";
import Certificates from "../Certificates";
import BigFront from "../Certificates/BigCard/BigFront";
import PapperFront from "../Certificates/PapperCard/PapperFront";
import FoldableCard from "../Certificates/FoldableCard";
import Style from "../Packing.module.scss";
import usePackingDetails from "./usePackingDetails";
import PassAll from "../PassAll";
import RemarksTable from "../../../Global/RemarksTable";
import { SearchFilters } from "@wac-ui-dashboard/wac_component_library";
import { Table } from "../../../Global/Table";
import NewFrontCard from "../Certificates/VisitingCardOne/NewFrontCard";

const PackingDetails = ({ id }) => {
  const {
    handleCloseViewModal,
    handleEditClose,
    handlePageSize,
    handlePagination,
    handleView,
    getRow,
    handleConfirm,
    handleConfirmModal,
    setPackingTypeId,
    setSubmissionStatus,
    handleEditClick,
    handlePassAllModal,
    handlePassAll,
    setRemarks,
    handleModalClose,
    globalRemarkModal,
    isFetching,
    itemId,
    tableFields,
    disableMultiSelect,
    packingList,
    packingState,
    paginationOptions,
    visitingOneFrontPrintRef,
    papperFrontPrintRef,
    bigFrontPrintRef,
    foldableCardRef,
    vistingDuplexRef,
    handleSearchInput,
  } = usePackingDetails({ id });
  let certificateType = packingState?.cerificateData?.[0]?.certificate_type;
  return (
    <>
      <div className={`row gx-3 ${Style.multicolumn_wrapper}`}>
        <div className="col">
          <div className="pro-d-flex pro-justify-end">
            <SearchFilters
              showDateRange={false}
              onSearchInput={handleSearchInput}
              showFilters={true}
              showActions={false}
              SearchIcon={
                <span className="material-symbols-outlined"> search </span>
              }
            />
            <div className={Style.btns}>
              <button
                className={`${Style.Print_btn} pro-btn pro-items-center pro-btn-outline`}
                onClick={handlePassAllModal}
              >
                <span className="material-symbols-outlined">check_circle</span>
                <span>Pass All</span>
              </button>
            </div>
            <button
              className="pro-btn pro-btn-outline-primary pro-items-center"
              onClick={handleView}
            >
              <span className="material-symbols-outlined">visibility</span>
              <span>View</span>
            </button>
          </div>
          <Table
            multiSelect={disableMultiSelect ? false : true}
            data={packingList?.data?.data || []}
            uniqueID={"id"}
            fields={tableFields}
            showCheckBox={true}
            getRow={getRow}
            perpage={10}
            assignable={true}
            editable={true}
            deletable={false}
            assignText={"Submit"}
            assignIcon={
              <span className="material-symbols-outlined">check_circle</span>
            }
            editIcon={<span className="material-symbols-outlined">badge</span>}
            editText={"View certificate"}
            handleAssign={handleConfirmModal}
            handleEdit={handleEditClick}
            clear={packingState.clear}
            loading={isFetching}
          />
        </div>
      </div>
      {packingList?.data?.data?.length > 0 && (
        <Pagination
          currentPage={parseInt(packingState.table.currentPage)}
          totalPageCount={Math.ceil(
            packingList?.data?.total_count / packingState.currentPageSize,
          )}
          onPageChange={handlePagination}
          options={paginationOptions}
          onActionChange={handlePageSize}
          center
        />
      )}
      <ModalLayout
        show={packingState?.showAddPackingModal}
        handleClose={handleConfirmModal}
        title={"Choose status of submission?"}
      >
        <div className="pro-m-5">
          <AddStatus
            handleConfirm={handleConfirm}
            handleConfirmModal={handleConfirmModal}
            setSubmissionStatus={setSubmissionStatus}
            itemId={itemId}
            setPackingTypeId={setPackingTypeId}
            setRemarks={setRemarks}
          />
        </div>
      </ModalLayout>

      <ModalLayout
        show={packingState?.viewModal}
        handleClose={handleCloseViewModal}
        propStyle={{ root: Style.viewModal }}
      >
        <div className="pro-m-5">
          <View />
        </div>
      </ModalLayout>
      <ModalLayout
        show={packingState?.showPassAllModal}
        handleClose={handlePassAllModal}
        title={"Pass All"}
      >
        <div className="pro-m-5">
          <PassAll
            handlePassAll={handlePassAll}
            itemId={packingState.selectedId}
          />
        </div>
      </ModalLayout>

      <ModalLayout
        show={packingState?.showCertificate}
        handleClose={handleEditClose}
        propStyle={{ root: `certificate-modal ${Style.modal_root}` }}
        closeIcon={<span className="material-symbols-outlined">close</span>}
        title={" "}
      >
        <div className="pro-m-5  modal-content-wrap"> 
          {certificateType === 1 && (
            <NewFrontCard
              visitingOneFrontPrintRef={visitingOneFrontPrintRef}
              isFrontOnly
            />
          )}
          {certificateType === 2 && (
            <BigFront bigFrontPrintRef={bigFrontPrintRef} isFrontOnly />
          )}
          {certificateType === 3 && (
            <PapperFront papperFrontPrintRef={papperFrontPrintRef} isFrontOnly />
          )}
          {certificateType === 4 && (
            <FoldableCard foldableCardRef={foldableCardRef} isFrontOnly />
          )}
        </div>
      </ModalLayout>
      <ModalLayout
        show={globalRemarkModal}
        handleClose={handleModalClose}
        title={"Remarks"}
        propStyle={{ root: "pro-modal-xxl" }}
        closeIcon={<span className="material-symbols-outlined">close</span>}
      >
        <div className="pro-m-5">
          <RemarksTable />
        </div>
      </ModalLayout>
    </>
  );
};

export default PackingDetails;
